import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Person from '../Person';
import Stuff from '../Stuff';
import CashDesk from '../CashDesk';
import BankAccount from '../BankAccount';

export default class Tafsil extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            fromautoComplete: this.isNull(props.FromAutoComplete) ? false : props.FromAutoComplete,
            onSetTafsil: this.isNull(props.OnSetTafsil) ? null : props.OnSetTafsil,
            callbackData: this.isNull(props.CallbackData) ? null : props.CallbackData,
            caller: props.Caller,
            tafsilType: (this.isNull(props.TafsilType) ? null : props.TafsilType),
            data: null,
            loading: true,
            version: this.uuidv4()
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.getData();
    }
    getData() {
        this.httpPost("api/v1/account/get", {
            id: this.state.id,
            tafsilType: this.state.tafsilType,
            type: 4,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.organizationId = data.global.company.id;
                    this.setState({
                        version: this.uuidv4(),
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.parentCode)) this.state.data.record.parentCode = 0;
        if (this.isBlank(this.state.data.record.objectId)) this.state.data.record.objectId = 0;
        this.httpPost("api/v1/account/save", {
            id: this.getCurrentFormId(),
            organizationId: this.state.data.global.company.id,
            title: this.state.data.record.title,
            fullCode: parseInt(this.state.data.record.fullCode),
            code: this.state.data.record.code,
            parentCode: parseInt(this.state.data.record.parentCode),
            objectId: parseInt(this.state.data.record.objectId),
            type: this.state.data.record.type,
            accountTypeId: this.state.data.record.accountTypeId,
            accountTafsilType: this.state.data.record.accountTafsilType,     
            divisionType: this.state.data.record.divisionType
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    if (this.state.fromautoComplete) {
                        if (this.isNull(this.state.onSetTafsil)) {
                            this.state.caller.setTafsil({
                                id: data.record.id,
                                value: data.record.fullCode,
                                accountTafsilType: data.record.accountTafsilType,
                                label: this.state.data.record.title
                            }, this.state.callbackData.bodyId);
                        }
                        else {
                            this.state.onSetTafsil({
                                id: data.record.id,
                                value: data.record.fullCode,
                                accountTafsilType: data.record.accountTafsilType,
                                label: this.state.data.record.title
                            }, this.state.callbackData.bodyId);
                        }
                    }
                    else
                        this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPerson(e) {
        if (this.state.fromautoComplete) {
            if (this.isNull(this.state.onSetTafsil)) {
                this.state.caller.setTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 1,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
            else {
                this.state.onSetTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 1,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
        }
        else
            this.state.caller.refreshData();
        this.closeMe();
    }
    setPerson(e) {
        if (this.state.fromautoComplete) {
            if (this.isNull(this.state.onSetTafsil)) {
                this.state.caller.setTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 1,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
            else {
                this.state.onSetTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 1,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
        }
        else
            this.state.caller.refreshData();
        this.closeMe();
    }
    setStuff(e) {
        if (this.state.fromautoComplete) {
            if (this.isNull(this.state.onSetTafsil)) {
                this.state.caller.setTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 2,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
            else {
                this.state.onSetTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 2,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
        }
        else
            this.state.caller.refreshData();
        this.closeMe();
    }
    setBankAccount(e) {
        if (this.state.fromautoComplete) {
            if (this.isNull(this.state.onSetTafsil)) {
                this.state.caller.setTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 3,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
            else {
                this.state.onSetTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 3,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
        }
        else
            this.state.caller.refreshData();
        this.closeMe();
    }
    setCashDesk(e) {
        if (this.state.fromautoComplete) {
            if (this.isNull(this.state.onSetTafsil)) {
                this.state.caller.setTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 4,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
            else {
                this.state.onSetTafsil({
                    id: e.accountId,
                    value: e.fullCode,
                    accountTafsilType: 4,
                    label: e.label
                }, this.state.callbackData.bodyId);
            }
        }
        else
            this.state.caller.refreshData();
        this.closeMe();
    }    
    setTafsilType(e) {
        //renew code
        if (e === 5 || e === 6) {
            this.state.tafsilType = e;
            this.getData();
        }
        else {
            this.setState({ tafsilType: e });
        }
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "85%" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="editDetailAccountModalLabel">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش" : "افزودن"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.isNull(this.state.tafsilType) && this.state.data.record.id === this.defaultGuid() &&
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="code" className="title1">ماهیت حساب تفصیلی</label>
                                                <select onChange={e => this.setTafsilType(parseInt(e.target.value))} defaultValue={this.state.tafsilType} autocomplete="off" className="form-control input-sm" >
                                                    <option value="">انتخاب نمایید</option>
                                                    <option value="0">تفصیل عادی</option>
                                                    <option value="1">مشتری و شخص</option>
                                                    <option value="2">کالا و خدمت</option>
                                                    <option value="3">حساب بانکی</option>
                                                    <option value="4">صندوق</option>
                                                    <option value="5">مرکز درآمد</option>
                                                    <option value="6">مرکز هزینه</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {((this.state.data.record.id === this.defaultGuid() && (this.state.tafsilType === 0 || this.state.tafsilType === 5 || this.state.tafsilType === 6)) || this.state.data.record.id !== this.defaultGuid()) && <div className="row" key={"version_" + this.state.version}>
                                    <div className="col-sm-6" id="account_modal_name_field">
                                        <div className="form-group">
                                            <label className="title1">عنوان <span className="red">*</span></label>
                                            <input onChange={e => this.state.data.record.title = e.target.value} defaultValue={this.state.data.record.title} autocomplete="off" onkeypress="return isCharacterKey(event)" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="code" className="title1">کد حساب </label>
                                            <input onChange={e => this.state.data.record.code = e.target.value} defaultValue={this.state.data.record.code} autocomplete="off" type="text" className="form-control input-sm" maxlength="10" />
                                        </div>
                                    </div>
                                    {this.state.data.record.type === 4 && this.state.data.record.accountTafsilType === 0 && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="code" className="title1">نوع حساب </label>
                                            <select onChange={e => this.state.data.record.accountTypeId = e.target.value} defaultValue={this.state.data.record.accountTypeId} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید ...</option>
                                                {this.state.data.accountTypes.map(t => <option value={t.id}>{t.name}</option>)}
                                            </select>
                                        </div>
                                    </div>}

                                    {this.state.tafsilType ===6 && this.state.data.global.company.mainBussinessType === 4 && <div className="col-lg-3">
                                        <label className="form-label">نحوه سرشکن</label>
                                        <select onChange={e => this.state.data.record.divisionType = e.target.value} defaultValue={this.state.data.record.divisionType} autoComplete="off" type="text" className="form-input">
                                            <option value={this.getDefaultGuid()}>انتخاب نمایید ...</option>
                                            <option value="0">هر واحد به اندازه کل مبلغ</option>
                                            <option value="1">تعداد نفرات</option>
                                            <option value="2">متراژ</option>
                                            <option value="3">تعداد پارکینگ</option>
                                            <option value="4">مساوی بین واحدها</option>
                                            <option value="5">سهم واحد از کل ساختمان</option>
                                        </select>
                                    </div>}
                                </div>}

                                {(this.state.tafsilType === 1) && <Person Caller={this.state.caller ? this.state.caller : this} FromautoComplete={true} Inline={true} Id={this.state.data.record.id === this.defaultGuid() ? this.getDefaultGuid() : this.state.data.record.tafsilObjectId} />}
                                {(this.state.tafsilType === 2) && <Stuff Caller={this.state.caller ? this.state.caller : this} FromAutoComplete={true} Inline={true} Id={this.state.data.record.id === this.defaultGuid() ? this.getDefaultGuid() : this.state.data.record.tafsilObjectId} />}
                                {(this.state.tafsilType === 3) && <BankAccount Caller={this.state.caller ? this.state.caller : this} FromAutoComplete={true} Inline={true} Id={this.state.data.record.id === this.defaultGuid() ? this.getDefaultGuid() : this.state.data.record.tafsilObjectId} />}
                                {(this.state.tafsilType === 4) && <CashDesk Caller={this.state.caller ? this.state.caller : this} FromAutoComplete={true} Inline={true} Id={this.state.data.record.id === this.defaultGuid() ? this.getDefaultGuid() : this.state.data.record.tafsilObjectId} />}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            {((this.state.data.record.id === this.defaultGuid() && (this.state.tafsilType === 0 || this.state.tafsilType === 5 || this.state.tafsilType === 6)) || (this.state.data.record.id !== this.defaultGuid() && this.state.fromautoComplete === false)) && <button type="button" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
            ];

        return contents;
    }
}